import { render } from "./coursewareUploadVideo.vue?vue&type=template&id=91af8a96&scoped=true"
import script from "./coursewareUploadVideo.vue?vue&type=script&lang=js"
export * from "./coursewareUploadVideo.vue?vue&type=script&lang=js"

import "./coursewareUploadVideo.vue?vue&type=style&index=0&id=91af8a96&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91af8a96"]])

export default __exports__